import { Button, makeStyles, MenuItem, TextField, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getUserPreference } from "../../../utilities/common";

const useStyles = makeStyles((theme)=> ({
    root: {
        '& .MuiTextField-root': {
          marginTop: theme.spacing(1),
          marginBottom: theme.spacing(1)
        }
    },
    inputFileText: {
        margin: theme.spacing(1) 
    }
}))

function UploadResendOrderForm(props){
    const {branches, onDataChange} = props;
    const classes = useStyles();
    const {t} = useTranslation('resendOrders');
    const userPref = getUserPreference();

    const [date, setDate] = useState();
    const [branch, setBranch] = useState("");
    const [file, setFile] = useState();


    useEffect(() => {
        //Set initial warehouse to current user area
        if(branches.length > 0 && branch === ""){
            setBranch(userPref.userCity)
        }
    }, [branches])

    useEffect(() => {
        onDataChange(date, branch, file)
    }, [date, branch, file])
    
    return (
        <React.Fragment>
            <form className={classes.root}>
                {/* <TextField
                    select
                    variant="outlined"
                    required
                    label={t('warehouse')}
                    fullWidth
                    value={branch}
                    onChange={(event)=>{setBranch(event.target.value)}}
                >
                    {branches.map((branch, index) => (
                        <MenuItem key={index} value={branch.id}>{branch.name}</MenuItem>
                    ))}
                </TextField> */}
                <TextField 
                    variant="outlined"
                    required
                    label={t('order_date')}
                    type="date"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    onChange={(event)=>{setDate(event.target.value)}}
                />
                <input
                    id='file-input'
                    hidden
                    type='file'
                    accept=".xlsx, .xls, .csv"
                    onChange={(event)=>{setFile(event.target.files[0])}}
                />
                <div style={{display: 'flex', flexDirection: 'row'}}>
                    <label htmlFor='file-input' style={{flex: 1}}>
                        <Button color="secondary" variant='contained' component="span">
                            {t('select_file')}
                        </Button>
                    </label>
                    <Typography
                        className={classes.inputFileText}
                        variant='body2' 
                        align='left'
                        noWrap
                        style={{ flex: 2, width: '100%'}}
                    >
                        {file && file.name || t('common:file_select_message')}
                    </Typography>
                </div>
            </form>
        </React.Fragment>
    )
}

export default UploadResendOrderForm